import React from 'react';

import Icon from 'components/common/Icons/base/Icon/Icon';

import { Button } from 'components/DesignSystem/Button';
import { TextInput } from 'components/DesignSystem/TextInput';
import { TagsFilter } from 'components/widgets/ReportsHome/ReportsListTable/filters/TagsFilter/TagsFilter';
import { UseReportsTemplatesLogic } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates.logic';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/TemplatesFilters/TemplatesFilters.module.scss';

interface Props {
    logic: UseReportsTemplatesLogic['logic'];
}

export const TemplatesFilters = ({ logic }: Props) => {
    return (
        <div className={classes.filterContainer}>
            <TextInput
                placeholder={'Search by name...'}
                className={classes.searchField}
                value={logic.getSearchValue()}
                onChange={(e) => logic.handleSearchChange(e.target.value)}
                onClear={() => logic.handleSearchChange('')}
                endIcon={<Icon name={'search'} size={'16px'} color={'var(--text-placeholder)'} />}
            />

            <TagsFilter
                selectedTag={logic.getSelectedTag()}
                handleSelectedTagChange={logic.handleTagSelectionChange}
                tagOptions={logic.tagOptions}
            />
            <Button
                startIcon={<Icon name={'filter-clear'} size={'15px'} color={'var(--button-secondary-fg)'} />}
                variant={'tertiary'}
                onClick={logic.handleClearFilters}
            >
                Clear filters
            </Button>
        </div>
    );
};
